'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationPropType = _propTypes2.default.oneOf(['small', 'large']);

exports.default = notificationPropType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Notification/notificationPropType.js
// module id = 622
// module chunks = 11